import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  margin: 30px 0;
  display: table;
  width: 100%;

  dl {
    display: table-cell;
    width: 12%;
    text-align: center;
    font-weight: bold;
    position: relative;
    vertical-align: middle;

    &:after {
      content: "";
      width: 1px;
      height: 30px;
      background-color: #ccc;
      display: inline-block;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &:last-child:after {
      display: none;
    }
  }

  dt {
    font-size: 15px;
    color: #666;
  }

  dd {
    font-size: 35px;
    height: 46px;
  }
`;

const DashboardDiv = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>;
};

export default DashboardDiv;
